import { useDynamicParams } from 'aem-libs-react-ts/src/hooks/useDynamicParams'

import { LOAN_AMOUNT_BOUNDARY_FOR_DURATION, LOAN_DURATION_HIGHER_MAX } from '../constants'
import { loansConsolidationStore } from '../store'
import type { LoansConsolidationParams } from '../types'

export const useLoanDurationMax = () => {
  const params = useDynamicParams<LoansConsolidationParams>()
  const values = loansConsolidationStore.useStoreData()

  const loanAmountBoundaryForDuration = params.loanAmountBoundaryForDuration || LOAN_AMOUNT_BOUNDARY_FOR_DURATION
  const loanDurationHigherMax = params.loanDurationHigherMax || LOAN_DURATION_HIGHER_MAX

  const totalLoanAmount = values.loanAmount + values.extraLoanAmount
  const loanDurationMax =
    totalLoanAmount <= loanAmountBoundaryForDuration ? params.loanDurationInputConfig.max : loanDurationHigherMax
  return {
    loanDurationMax,
    loanDurationMaxParams: {
      loanDurationHigherMax,
      loanDurationLowerMax: params.loanDurationInputConfig.max,
      loanAmountBoundaryForDuration
    }
  }
}
